import packageJson from "../package.json";

type EnvName = "dev" | "preview" | "dev:sw" | "dev:sw2" | "test" | "prod";

// dev:sw2 utiliza /opt/homebrew/etc/nginx/servers/fabricca.pro.test.conf para tudo (front + back)

const location =
  typeof window !== "undefined"
    ? window.location // dom
    : self.location; // sw

function urlContains(url: string): boolean {
  return location.href.indexOf(url) !== -1;
}

export const envName: EnvName = urlContains("http://localhost:517")
  ? "dev"
  : urlContains("http://localhost:417")
    ? "preview"
    : urlContains("https://localhost/")
      ? "dev:sw"
      : urlContains("https://fabricca.pro.test/")
        ? "dev:sw2"
        : urlContains("https://test.fabricca.pro")
          ? "test"
          : "prod";

export const version = packageJson.version;

// `test` (UAT/homolog) é prod-like: NÃO conta como devMode (storage cifrado, sem
// UI de debug, usa os proxies). Só dev/preview/dev:sw/dev:sw2 são devMode.
export const devMode =
  import.meta.env.DEV || (envName !== "prod" && envName !== "test");

const apiByEnvName: Record<EnvName, string> = {
  dev: "https://fabricca.pro", // back de prod (forçado)
  preview: "https://fabricca.pro", // back de prod (forçado)
  "dev:sw": "https://fabricca.pro", // back de prod (forçado)
  "dev:sw2": "https://fabricca.pro.test", // back de dev (forçado)
  test: location.origin, // UAT/homolog: back same-origin (test.fabricca.pro)
  prod: location.origin, // back de prod
};

export const env = {
  api: apiByEnvName[envName] + "/api",
  secretKey: "dF6WyZmz3WVk6iGV4eTiAqnHmwTx15",
};

/**
 * @returns string `https://fabricca.pro` or `https://meuplay.fabriccamultimidia.com`
 */
export function getHost(): string {
  return apiByEnvName[envName];
}
